<template>
    <div>
        <div class="searchItem" v-show="$global.userType==0">
            <span class="searchtips"><span style="color: #F56C6C;margin-right: 4px;" v-if="!hideStar">*</span>客户:</span>
            <div class="search">
                <el-select
                    ref="editCell"
                    style="width:180px;"
                    v-model="orderForm.cname"
                    placeholder="请输入客户名"
                    filterable
                    remote
                    value-key="id"
                    :remote-method="remoteMethod"
                    clearable
                    :allow-create="createAlllow?true:false"
                    @visible-change="edit($event)"
                    @change="changeAuto">
                    <el-option
                        v-for="item in cList"
                        :key="item.id"
                        :label="item.value"
                        :value="item">
                    </el-option>
                </el-select>
                <span
                    class="cl_icon"
                    @click="customerListDialog = true"
                    v-if="tips"
                    ><i class="el-icon-more"
                /></span>
            </div>
        </div>
        <el-dialog :visible.sync="customerListDialog" title="客户列表" width="60%">
            <CustomerList
                ref="customerList"
                @close="closeCustomer(arguments)"
                style="overflow: auto"
            ></CustomerList>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="customerSelected"
                    >确认</el-button
                >
                <el-button @click="customerListDialog = false"
                    >取消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CustomerList from "@/components/customer/list";
export default {
    components:{
        CustomerList,
    },
    props:{
        orderForm:{
            type:Object,
            default:function() {
				return {};
			}
        },
        tips:{
            type:Boolean,
            default:false,
        },
        hideStar:{
            type:Boolean,
            default:false,
        },
        createAlllow:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return{
            customerListDialog:false,
            rules:{
                cid:[{required:true,message:'请选择客户'}]
            },
            cList:[],
            customName:'',
        }
    },
    created(){
        this.remoteMethod();
    },
    mounted() {	
	},
    methods:{
        edit(e){
            if(e){
                this.$refs.editCell.focus();
            }
        },
        remoteMethod(val){
            let obj = {}
            if(val!=null){
                obj.customer = val;
            }
            if(this.$global.customerState){
                obj.state = this.$global.customerState;
            }
            this.cList = [];
            this.$api.customerlistCustomer(obj).then((res)=>{
                if(res.data.code==1){
                    let data = res.data.data;
                    data.forEach(e=>{
                        let temp = {
                            id:e.id,
                            value:e.cname,
                        }
                        this.cList.push(temp);
                    })
                }
            })
        },
        changeAuto(e){
            if(e&&typeof(e)=='object'){
                this.orderForm.cid = e.id;
                this.change(e.id);
            }else if(e){
                this.orderForm.cid = 0;
                this.customName = e;
            }else{
                this.orderForm.cid = '';
            }
        },
        change(e){
            this.$emit("change",e);
            if(!this.hideStar){
                this.$global.cid = e;
            }
        },
        addCustomer(callback){
            if(!this.customName){
                this.$common.error('客户未填写');
                return;
            }
            if(!this.$common.hasLimits('customerAdd')){
                this.$common.error('没有新建客户权限，请选择客户');
                return;
            }
            this.$confirm("确认", {
                title: "客户不存在",
                message: "是否新建该客户?",
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                   this.$api.customergetCNumber().then((res) => {
                        if (res.data.code == 1) {
                            let number = res.data.data;
                            let arr = [];
                            let obj = {
                                cnumber:number,
                                cname:this.customName,
                                beginBill:0,
                                valid:0,
                                contacts:JSON.stringify(arr),
                                emp: localStorage.getItem("userid"),
                                saleName:localStorage.getItem("name"), 
                            }
                            this.$api.customeraddCustomer(obj).then(res1=>{
                                if(res1.data.code==1){
                                    this.orderForm.cid = res1.data.data.id;
                                    this.orderForm.invoicetype = 0;
                                    this.orderForm.contact = "";
                                    callback();
                                }else{
                                    this.$common.error('客户创建失败');
                                }
                            })
                        }
                    }); 
                },
                () => {}
            )
            
        },
        customerSelected() {
            this.$nextTick(() => {
                this.$refs.customerList.checkCustomer();
            });
        },
        closeCustomer(value) {
            let cid = value[0].id;
            this.orderForm.cid = cid;
            this.orderForm.cname = value[0].cname;
            this.change(cid);
            this.customerListDialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>

.cl_icon {
    position: relative;
    right: 25px;
    background: #fff;
}
</style>